"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'neutral-secondary' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', viewBox: '0 0 24 24' }, restProps),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: 'M11.791 13.4l4.26-4.254a.501.501 0 01.708 0l.694.694a.5.5 0 010 .707l-5.308 5.302a.501.501 0 01-.708 0l-5.29-5.284a.5.5 0 010-.707l.694-.694a.501.501 0 01.708 0l4.242 4.237z', id: 'sIcChevronDownSm' })),
        react_1.default.createElement("use", { xlinkHref: '#sIcChevronDownSm', fillRule: 'evenodd' })));
}
exports.default = SvgComponent;
